module.exports = __webpack_public_path__ + "static/media/palma-1.269bb430.webp";